import * as React from 'react';
const SvgComponent = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    viewBox="0 0 23.458 26.25"
    {...props}
  >
    <path
      fill="currentColor"
      d="M22.595.176a.75.75 0 0 1 .093 1.056l-8.39 9.999 8.853 12.412a1.656 1.656 0 0 1 .124 1.713 1.65 1.65 0 0 1-1.465.894h-3.79a1.64 1.64 0 0 1-1.345-.693l-6.616-9.276-8.14 9.701a.75.75 0 1 1-1.149-.964l8.39-9.998L.306 2.608A1.651 1.651 0 0 1 1.648 0h3.79a1.65 1.65 0 0 1 1.344.693l6.616 9.276L21.539.268a.75.75 0 0 1 1.056-.092M5.507 1.517a.15.15 0 0 0-.069-.017H1.65a.15.15 0 0 0-.122.237l9.19 12.885 7.179 10.065a.149.149 0 0 0 .123.063h3.788a.15.15 0 0 0 .078-.022.16.16 0 0 0 .055-.059.152.152 0 0 0-.011-.156l-9.19-12.884L5.561 1.564a.15.15 0 0 0-.054-.047"
    />
  </svg>
);
export default SvgComponent;
